import {Button, Flex, Typography} from 'antd';
import React from 'react';
import PropTypes from 'prop-types';
import {useCSContext} from 'Context/ContentStackContext';
import DialogWrapper from './DialogWrapper';
import styles from './styles';
import {GIFTING} from '../../giftingConstants';

const GiftDialogSuccess = ({openSuccessDialog, setOpenSuccessDialog, customerEmail}) => {
  const {artifacts} = useCSContext();

  return (
    <DialogWrapper closeDialogMethod={setOpenSuccessDialog} open={openSuccessDialog}>
      <Flex vertical gap={16} style={styles.container}>
        <img src={artifacts.gift_opened_icon} alt="" />
        <Typography.Title level={3} style={{margin: 0}}>
          {GIFTING.gifting_dialog_success.heading}
        </Typography.Title>
        <Typography.Text style={{textAlign: 'center'}}>
          {GIFTING.gifting_dialog_success.subtitle} {customerEmail}.
        </Typography.Text>
      </Flex>
      <div style={styles.buttonBox}>
        <Button type="primary" onClick={() => setOpenSuccessDialog(false)} style={styles.button}>
          {GIFTING.gifting_dialog_success.button_text}
        </Button>
      </div>
    </DialogWrapper>
  );
};

GiftDialogSuccess.propTypes = {
  openSuccessDialog: PropTypes.bool,
  setOpenSuccessDialog: PropTypes.func,
  customerEmail: PropTypes.any,
};

export default GiftDialogSuccess;
